import React from "react";
import * as styles from "./styles.module.scss";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faEnvelope,faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub} from '@fortawesome/free-brands-svg-icons';
import resume from "../../../static/patrick_wang_resume.pdf";
import classNames from "classnames";

const About = () => {
  return (
    <div id="about" className={classNames(styles.about, "section")}>
      <div>
      <div style={{fontSize: "2rem"}}>
        I'm a UC Berkeley graduate with a major in Electrical Engineering and Computer Science, currently working in software engineering. In the past, I 
        worked on some cool machine learning projects in <a href="https://launchpad.studentorg.berkeley.edu/" target="_blank" rel="noreferrer">Launchpad</a>&nbsp;
        and taught for the introductory course <a href="https://cs61a.org/" target="_blank" rel="noreferrer">CS 61A</a>. I also like to play some sports and 
        eat mac and cheese, among other things. I'm also from Maryland. Feel free to reach out!
      </div>
      <div style={{marginTop: "1rem"}}>
        <a className={styles.introLink} href="https://www.github.com/patwang123" target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>
        </a>
        <a className={styles.introLink} href="https://docs.google.com/document/d/1cyb8tbmiOJNjByCEqQF2d0v9EhJaOd9bFApWrW1EF98/edit?usp=sharing" target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faPaperclip}></FontAwesomeIcon>
        </a>
        <a className={styles.introLink} href="mailto:patwang123@berkeley.edu" target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon>
        </a>
        <a className={styles.introLink} href="https://www.linkedin.com/in/patwang123/" target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faLinkedin}></FontAwesomeIcon>
        </a>
      </div>
      </div>
    </div>

  )
}
export default About;